import AuditKendaraanTradoArsipMain from "../../features/audit-kendaraan/audit-kendaraan-trado/audit-kendaraan-trado-arsip/component/AuditKendaraanTradoArsipMain";

const AuditKendaraanTradoArsipPage = () => {
  return <AuditKendaraanTradoArsipMain />;
};

export default AuditKendaraanTradoArsipPage;
